import { motion } from "framer-motion";
import { heroBg, Nadshot } from "../Assets";

const Hero = () => {
  return (
    <section className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 py-8 pt-32 sm:py-12 sm:pt-40 md:py-24 md:pt-24 text-white text-center ">
      <video
        src={heroBg}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      ></video>

      <motion.div
        className="w-full space-y-6 flex flex-col items-center z-10 max-w-3xl mt-20 sm:mt-32 md:mt-48"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight">
          The Fastest Trading Bot on Monad
        </h1>

        <p className="text-base sm:text-lg text-gray-300 max-w-lg mx-auto">
          Swap fast. Trade memes. Built for Nads, By Nads. Powered by Monadscore.
        </p>
      </motion.div>

      <motion.div
        className="w-full mt-10 flex justify-center"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={Nadshot}
          alt="Hero"
          className="max-w-xs sm:max-w-sm md:max-w-lg w-full h-auto relative z-10 -mb-20 sm:-mb-32 md:-mb-48"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.div>
    </section>
  );
};

export default Hero;